import React from "react";
import Reveal from "../common/Reveal";

const StarterVideo: React.FC = () => {
  const youtubeId = "q4OBYhwRj3g";

  return (
    <section
      id="get-started"
      className="bg-gradient-to-b from-primary via-primary/98 to-primary py-20 sm:py-24"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 px-6 lg:flex-row lg:items-stretch">
        <Reveal className="w-full space-y-5 text-center lg:w-2/5 lg:text-left">
          <p className="text-xs uppercase tracking-[0.35em] text-accentNavy/45">
            Here&apos;s something to get started
          </p>
          <h2 className="font-display text-3xl text-accentNavy sm:text-4xl lg:text-5xl">
            Try a free song tutorial on us.
          </h2>
          <p className="text-base text-accentNavy/70 lg:text-lg">
            Before you even say yes to the full journey, sit with your
            instrument and learn along with this step-by-step YouTube lesson.
            No login, no commitment&mdash;just a small taste of how guided and
            relaxed your practice can feel.
          </p>
          <p className="text-sm text-accentNavy/60 lg:text-base">
            If you enjoy this, the full program simply gives you more of the
            same clarity, structure, and accountability&mdash;with you and your
            ukulele at the centre.
          </p>
        </Reveal>

        <Reveal
          delay={140}
          className="w-full lg:w-3/5"
        >
          <div className="relative mx-auto w-full max-w-xl overflow-hidden rounded-3xl border border-accentNavy/15 bg-gradient-to-br from-white via-slate-50 to-slate-100 shadow-[0_24px_70px_-35px_rgba(9,32,63,0.95)]">
            <div className="relative aspect-video w-full overflow-hidden">
              <iframe
                src={`https://www.youtube.com/embed/${youtubeId}?rel=0&modestbranding=1`}
                title="Ukulele tutorial to get started"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute inset-0 h-full w-full"
              />
            </div>
            <div className="flex items-center justify-between gap-3 border-t border-accentNavy/10 bg-white/95 px-4 py-3">
              <div className="space-y-0.5 text-left">
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accentNavy/55">
                  Demo lesson
                </p>
                <p className="text-sm text-accentNavy/80">
                  Follow along and feel what a guided session is like.
                </p>
              </div>
              <span className="rounded-full bg-accentNavy/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-accentNavy/70">
                1 click · free
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default StarterVideo;

